module.exports = __webpack_public_path__ + "static/media/sr_icon.4c2585fd.svg";